import { md5 } from "js-md5";

import { checkQueryParams } from "./functions/checkQueryParams";
import { getHexRemainder } from "./functions/getHexRemainder";

import type { ABTestGroup } from "./types/ABTestGroup";

// ABテストのグループ名のシード. ABテストを追加する際には、ABテストごとにtypeを追加する
type ABTestSeed =
  | "AB_TEST_SIGNUP_BUTTON"
  | "AB_TEST_REFRESH_TOKEN"
  | "AB_TEST_SKIP_ADD_TO_CART_STEP";

const enabledEventIdListOfSkipPurchaseSteps = [
  // dev環境
  "evt_eV3DFq7msEZ9ec2Wykta",
  // 本番環境
  // 相坂優歌 3rd Live「ピュリファイ」【配信チケット申し込みページ】
  "evt_Hglu5vpqq2FjA9wS76fE",
  // Paradox Live Dope Space
  "evt_Bdds2qS3yyeHPmkbHaEX",
];

const getGACookie = () => {
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    cookie = cookie.trim();
    // _gaから始まるcookieを探す
    if (cookie.indexOf("_ga=") === 0) {
      return cookie.substring("_ga=".length, cookie.length);
    }
  }
  return undefined;
};

export const enableSkipPurchaseSteps = (eventId: string) => {
  if (checkQueryParams() !== undefined) {
    return true;
  }

  if (!enabledEventIdListOfSkipPurchaseSteps.includes(eventId)) {
    return false;
  }

  return enableABTestNewFeature("AB_TEST_SKIP_ADD_TO_CART_STEP");
};

export const enableABTestNewFeature = (abTestSeed: ABTestSeed): boolean => {
  try {
    // URLパラメータにab_test_groupが指定されている場合は、その値で機能を出すかどうかを判定する
    const queryParamsGroup = checkQueryParams();
    if (queryParamsGroup !== undefined) {
      return queryParamsGroup === "B_GROUP";
    }

    const abTestGroup = getABTestGroup(abTestSeed);
    if (abTestGroup === undefined) {
      return false;
    }

    return abTestGroup === "B_GROUP";
  } catch (e) {
    console.error(e);
    return false;
  }
};

const getABTestGroup = (abTestSeed: ABTestSeed): ABTestGroup => {
  const pseudoUUID = getGACookie();
  if (pseudoUUID === undefined) {
    return undefined;
  }

  // ga1.2.1234567890.1234567890のような形式から,1234567890.1234567890の部分を取得
  const pseudoUUIDArray = pseudoUUID.split(".");
  if (pseudoUUIDArray.length !== 4) {
    return undefined;
  }
  const pseudoUUIDWithoutVersion = pseudoUUIDArray.slice(2).join(".");

  const hash = md5.create();
  hash.update(abTestSeed + pseudoUUIDWithoutVersion);
  const hexDigest = hash.hex();

  return getHexRemainder(hexDigest);
};
